// dependecies import ==>
import React from "react";
// assets and scss import ==>
import "./vcAgeWiseTableView.scss";
import dropdownArrow from "../../../../../assets/down_arrow_white.svg";
import editIcon from "../../../../../assets/edit-icon1.svg";
import AddIcon from "../../../../../assets/rx_add.svg";
import DeleteIcon from "../../../../../assets/delete_icon_pre.svg";

import moment from "moment";
// project file import ==>

// constant import ==>

const VCAgeWiseTableView = (props) => {
  const {
    ageWiseHeader,
    expand,
    vaccines,
    searchVaccine,
    handleToggleArrow,
    handleEditVaccineModal,
    handleAddVaccineModal,
    handleDeleteVaccine,
  } = props;

  // Helper Methods ===>

  const getVaccineClassName = (item) => {
    let className = "vc-age-wise-table-view-vaccines ";

    if (item.vaccinated_date) {
      className += "vc-age-wise-table-view-vaccinated";
    } else if (item.scheduled_date) {
      if (
        moment()
          .hours(0)
          .minutes(0)
          .seconds(0)
          .milliseconds(0)
          .isAfter(
            moment(new Date(item.scheduled_date), "YYYY/MM/DD")
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0)
          )
      ) {
        className += "vc-age-wise-table-view-due-date-passed";
      }
    }

    return className;
  };

  // <===

  // Display UI ===>

  const displayVaccineChartSubHeader = () => {
    return (
      <div
        className="vc-age-wise-table-view-subheader"
        style={{ width: window.innerWidth > 768 ? "" : "max-content" }}
      >
        <div
          className={
            window.innerWidth > 768
              ? "col-3 p-0"
              : "vc-table-mobile-view-vaccine-name"
          }
          style={{
            flex: window.innerWidth > 768 ? "0 0 22%" : "",
            maxWidth: window.innerWidth > 768 ? "22%" : "",
          }}
        >
          Vaccine Name
        </div>
        <div
          className={
            window.innerWidth > 768 ? "col-1 p-0" : "vc-table-mobile-view"
          }
        >
          Vaccine Brand
        </div>
        <div
          className={
            window.innerWidth > 768
              ? "col-1 p-0"
              : "vc-table-mobile-view-due-date"
          }
        >
          Due Date
        </div>
        <div
          className={
            window.innerWidth > 768 ? "col-2 p-0" : "vc-table-mobile-view"
          }
        >
          Vaccinated Date
        </div>
        <div
          className={
            window.innerWidth > 768
              ? "col-1 p-0"
              : "vc-table-mobile-view-height"
          }
        >
          Height
        </div>
        <div
          className={
            window.innerWidth > 768
              ? "col-1 p-0"
              : "vc-table-mobile-view-weight"
          }
        >
          Weight
        </div>
        <div className={window.innerWidth > 768 ? "col-3 p-0" : ""}>
          Head Circumference
        </div>
      </div>
    );
  };

  const displayVaccineChartContent = () => {
    return (
      <div style={{ width: window.innerWidth > 768 ? "" : "max-content" }}>
        {vaccines
          ?.filter((ele) =>
            ele.name?.toLowerCase()?.includes(searchVaccine?.toLowerCase())
          )
          .map((item, ind) => (
            <div key={ind} className={getVaccineClassName(item)}>
              <div
                className={
                  "vc-table " +
                  (window.innerWidth > 768
                    ? "col-3 p-0"
                    : "vc-table-mobile-view-vaccine-name")
                }
                style={{
                  flex: window.innerWidth > 768 ? "0 0 22%" : "",
                  maxWidth: window.innerWidth > 768 ? "22%" : "",
                }}
              >
                <div style={{ maxWidth: "70%" }}>{item.name}</div>
                {item.isEditable && (
                  <div className="vc-table-edit-icon">
                    <img
                      src={editIcon}
                      alt=""
                      onClick={() => handleEditVaccineModal(item)}
                    />
                  </div>
                )}
                {item?.custom_vaccine && item.isEditable && (
                  <div className="vc-table-delete-icon">
                    <img
                      src={DeleteIcon}
                      alt=""
                      onClick={() => handleDeleteVaccine(item)}
                    />
                  </div>
                )}
              </div>
              <div
                className={
                  (window.innerWidth > 768
                    ? "col-1 p-0 "
                    : "vc-table-mobile-view ") +
                  (!item.vaccine_brand_name ? "vc-placeholder" : "")
                }
              >
                {item.vaccine_brand_name
                  ? item.vaccine_brand_name
                  : "Vaccine Brand"}
              </div>
              <div
                className={
                  (window.innerWidth > 768
                    ? "col-1 p-0 "
                    : "vc-table-mobile-view-due-date ") +
                  (!item.scheduled_date ? "vc-placeholder" : "")
                }
              >
                {item.scheduled_date ? item.scheduled_date : "Due Date"}
              </div>
              <div
                className={
                  (window.innerWidth > 768
                    ? "col-2 p-0 "
                    : "vc-table-mobile-view ") +
                  (!item.vaccinated_date ? "vc-placeholder" : "")
                }
              >
                {item.vaccinated_date
                  ? item.vaccinated_date
                  : "Vaccinated Date"}
              </div>
              <div
                className={
                  (window.innerWidth > 768
                    ? "col-1 p-0 "
                    : "vc-table-mobile-view-height ") +
                  (!item.height ? "vc-placeholder" : "")
                }
              >
                {item.height ? item.height : "Height"}
              </div>
              <div
                className={
                  (window.innerWidth > 768
                    ? "col-1 p-0 "
                    : "vc-table-mobile-view-weight ") +
                  (!item.weight ? "vc-placeholder" : "")
                }
              >
                {item.weight ? item.weight : "Weight"}
              </div>
              <div
                className={
                  (window.innerWidth > 768 ? "col-3 p-0 " : "") +
                  (!item.head_circumference ? "vc-placeholder" : "")
                }
              >
                {item.head_circumference ? item.head_circumference : "HC"}
              </div>
            </div>
          ))}
      </div>
    );
  };

  const displayAddVaccineButton = () => {
    return (
      <div className="vc-add-vaccine-button-container">
        <button
          className="vc-add-vaccine-button"
          onClick={handleAddVaccineModal}
        >
          <img src={AddIcon} alt="" className="vc-add-vaccine-icon" />
          Add Vaccine{" "}
        </button>
      </div>
    );
  };

  const displayVCAgeWiseTableView = () => {
    return (
      <div className="vc-age-wise-table-view">
        <div
          className="vc-age-wise-table-view-header"
          onClick={handleToggleArrow}
        >
          {ageWiseHeader}
          <img
            alt=""
            src={dropdownArrow}
            className={
              "vc-age-wise-table-view-header-dropdown " +
              (expand
                ? "vc-age-wise-table-view-header-dropdown-expand"
                : "vc-age-wise-table-view-header-dropdown-collapse")
            }
          />
        </div>
        {expand && (
          <>
            <div className="vc-age-wise-table-view-content">
              {displayVaccineChartSubHeader()}
              {displayVaccineChartContent()}
            </div>
            {displayAddVaccineButton()}
          </>
        )}
      </div>
    );
  };

  // <===

  return (
    <div className="vc-age-wise-table-view-container">
      {displayVCAgeWiseTableView()}
    </div>
  );
};

export default VCAgeWiseTableView;
